import { useLoading, MatchUp, Modal, Button, Typography, Paper, useBreakpoints, Danger } from "best-common-react";
import React, { useState } from "react";
import { DayOfGameDTO } from "../../types/TodaysTickets";
import { useTimezone } from "../../util/TimeUtil";
import TodaysTicketsGameRequest from "./TodaysTicketsGameRequest";
import clsx from "clsx";

type DayOfGameProps = {
  className?: string;
  game: DayOfGameDTO;
  refreshData?: () => void;
  allotment?: number;
  isLotto?: boolean;
  canRequestTickets?: boolean;
  isReadOnly?: boolean;
  hasBeenRequested?: boolean;
};

const TodaysTicketsGame = ({
  className,
  game,
  refreshData,
  allotment,
  isLotto = false,
  canRequestTickets = true,
  isReadOnly = false,
  hasBeenRequested = false,
}: DayOfGameProps) => {
  const { setLoading } = useLoading();
  const { isMobile } = useBreakpoints();
  const [requestOpen, setRequestOpen] = useState<boolean>(false);
  const [cannotRequestOpen, setCannotRequestOpen] = useState<boolean>(false);
  const tz = game.venue ? game.venue.timeZone : null;
  const { time, day, date } = useTimezone(game.gameDate, tz!, {
    startTimeTBD: false,
    statusCode: "",
    detailedState: "",
    codedGameState: "",
    abstractGameState: "",
    abstractGameCode: "",
  });
  const teamId: number = game.home.id;
  const allowedToRequest: boolean = !!game.ticketsLeft && game.ticketsLeft > 0 && !!allotment && allotment > 0;
  const alreadyEnteredLottery: boolean = hasBeenRequested && isLotto;

  return (
    <>
      <Modal show={cannotRequestOpen} size="md">
        <Modal.Header close={() => setCannotRequestOpen(false)}>Ticket Claim Restriction</Modal.Header>
        <Modal.Body>
          <Typography>
            You currently hold approved tickets for the selected game. To ensure equitable distribution, additional
            ticket requests for this event cannot be processed at this time.
          </Typography>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setCannotRequestOpen(false)}>Close</Button>
        </Modal.Footer>
      </Modal>
      <TodaysTicketsGameRequest
        isOpen={requestOpen}
        onSave={!!refreshData ? refreshData : () => {}}
        onClose={() => setRequestOpen(false)}
        gamePk={game.gamePk}
        game={game}
        teamId={teamId}
        ticketsLeft={game.ticketsLeft}
        allotment={allotment}
        isLotto={isLotto}
      />
      <div
        style={{
          opacity: alreadyEnteredLottery ? 0.5 : 1,
        }}
      >
        <Paper
          onClick={
            isReadOnly || alreadyEnteredLottery
              ? undefined
              : () => {
                  if (!canRequestTickets) {
                    setCannotRequestOpen(true);
                  } else if (allowedToRequest) {
                    setCannotRequestOpen(false);
                    setLoading(true);
                    setRequestOpen(true);
                  }
                }
          }
          className={clsx(className, { "w-100": isMobile })}
          styles={{
            background: "var(--color-surface-lowest)",
          }}
        >
          <div className="d-flex justify-content-between bcr-gap-5">
            <div className="d-flex flex-column">
              <Typography variant="titleMedium" elementStyles={{ weight: "bold" }}>
                {date}
              </Typography>
              <Typography>
                {day} <span className="bcr-ms-2">{time}</span>
              </Typography>
              <Typography>{game.venue.name}</Typography>
            </div>
            <div className="d-flex flex-column align-items-end">
              <MatchUp home={game.home} away={game.away} useSpots={true} logoSize="2rem" />
              {game.ticketsLeft !== undefined && (
                <Typography className="bcr-mt-2">{game.ticketsLeft} Ticket(s) Left</Typography>
              )}
            </div>
          </div>
          {alreadyEnteredLottery && (
            <Danger className="bcr-mt-1">You have already entered the lottery for this game.</Danger>
          )}
        </Paper>
      </div>
    </>
  );
};

export default TodaysTicketsGame;
